import type { JSX } from 'react';

import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';

export const CustomIconVerified = (props: SvgIconProps): JSX.Element => {
    return (
        <SvgIcon {...props}>
            <path d="M7.16659 18.75L5.58325 16.0833L2.58325 15.4167L2.87492 12.3333L0.833252 10L2.87492 7.66667L2.58325 4.58333L5.58325 3.91667L7.16659 1.25L9.99992 2.45833L12.8333 1.25L14.4166 3.91667L17.4166 4.58333L17.1249 7.66667L19.1666 10L17.1249 12.3333L17.4166 15.4167L14.4166 16.0833L12.8333 18.75L9.99992 17.5417L7.16659 18.75ZM9.12492 12.9583L13.8333 8.25L12.6666 7.04167L9.12492 10.5833L7.33325 8.83333L6.16659 10L9.12492 12.9583Z" />
        </SvgIcon>
    );
};
